<template>
  <div>
    <h1>Catalogue des Références (Boucle externe)</h1>
    <b-row id="toptab">
      <b-col md="4">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Rechercher" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Effacer</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2" offset-md="2">
        <b-form-group horizontal label="Emplacement" class="mb-0">
          <b-input-group>
            <b-form-input v-model="positionFilter" @input="searchEmplacement" placeholder="Rechercher un emplacement" />
            <b-input-group-append>
              <b-btn :disabled="!positionFilter" @click="positionFilter = null">Effacer</b-btn>
            </b-input-group-append>
          </b-input-group>
          </b-form-group>
      </b-col>
      <b-col md="2" offset-md="1" class="mb-0">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="addNewReference()"
        >Ajout d'une référence</b-button>
      </b-col>
    </b-row>
    <b-row class="option-row" style="margin-top: 3%;">
      <b-col md="4" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
      </b-col>
      <b-col md="6">
       <b-button
          class="lead-btn"
          size="sm"
          variant="primary"
          @click="toggleLeadTime()"
        >{{textBtnLeadTime}}
        </b-button>
        <b-button-group>
          <b-button disabled variant="success"> Ranking</b-button>
          <b-button variant="success" @click="filterRanking('A')">A</b-button>
          <b-button variant="success" @click="filterRanking('B')">B</b-button>
          <b-button variant="success" @click="filterRanking('C')">C</b-button>
          <b-button variant="success" @click="filterRanking('D')">D</b-button>
          <b-button variant="success" @click="filterRanking('')">Tous</b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-table
      id="my-table"
      ref="table"
      :bordered="bordered"
      :outlined="outlined"
      :busy.sync="isBusy"
      :items="getReferencesAsync"
      :fields="fields"
      :filter="filter"
      filter-debounce="400"
      :current-page="currentPage"
      :per-page="perPage"
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <!-- <b-spinner class="align-middle"></b-spinner> -->
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <!-- <template v-slot:cell(loops)="row">
        <b-badge variant="info" v-for="(loop) in row.item.loops" :key="loop">{{loop}}</b-badge>
      </template> -->
      <template v-slot:cell(reference.code_display)="row">
        <div class="text-wrapper size">
          <div @click="goTo('/andon/'+row.item.reference.code)" class="cursor">
            {{row.item.reference.code_display}}
          </div>
        </div>
      </template>
      <!-- <template v-slot:cell(detail)="row"> -->
        <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
        <!-- <b-button
          size="sm"
          @click="showDetail(row)"
          class="mr-2"
        >{{ row.detailsShowing ? 'Cacher' : 'Afficher'}} le détail </b-button>
        <br /> -->
        <!-- <b-button
          size="sm"
          style="font-size:12px;margin-left:10px;"
          @click="goTo('/andon/'+row.item.reference.code)"
          class="mr-2"
          variant="outline-primary"
        >Hippodrome</b-button> -->
      <!-- </template> -->
      <template v-slot:row-details="row">
        <b-button size="sm" @click="recomputeCards(row)" class="mr-2">Recalculer les cartes</b-button>
        <b-button size="sm" @click="printAllCards(detailsItems)" class="mr-2">Imprimer les cartes</b-button>
        <b-button size="sm" @click="printFlowrackTicket(row)" class="mr-2">Imprimer ticket flowrack</b-button>
        <b-button size="sm" @click="displayModalTmpCards(row)" class="mr-2">Créer cartes temporaires</b-button>
        <b-button-group>
          <b-button disabled variant="success"> Ranking :</b-button>
          <b-button :disabled="row.item.ranking == 'A'" variant="success" @click="changeRanking('A', row)">A</b-button>
          <b-button :disabled="row.item.ranking == 'B'" variant="success" @click="changeRanking('B', row)">B</b-button>
          <b-button :disabled="row.item.ranking == 'C'" variant="success" @click="changeRanking('C', row)">C</b-button>
          <b-button :disabled="row.item.ranking == 'D'" variant="success" @click="changeRanking('D', row)">D</b-button>
        </b-button-group>
        <b-card>
          <b-table striped hover :items="detailsItems" :fields="detailsFields">
              <template v-slot:cell(last_print_at)="row">
                <div>
                 {{ row.item.last_print_at == null ? '--' : row.item.last_print_at | moment('DD-MM-YYYY') }}

                </div>
              </template>
              <template v-slot:cell(supplier)="row">
                <div>
                 {{ row.item.supplier == null ? '--' : row.item.supplier.supplier }}
                </div>
              </template>
              <template v-slot:cell(Imprimer)="row">
                <div>
                    <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                    <b-button
                        size="sm"
                        variant="primary"
                        @click="printCard(row)"
                        class="mr-2"
                    >
                        <i class="fa fa-print" aria-hidden="true"></i>
                    </b-button>
                    </div>
                </template>
                <template v-slot:cell(Update)="row">
                    <div>
                    <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                    <b-button
                        size="sm"
                        variant="primary"
                        @click="goToUpdateCardInfos(row)"
                        class="mr-2"
                    >
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                    </b-button>
                    </div>
                </template>
          </b-table>
          <b-button size="sm" @click="showDetail(row)">Cacher le détail</b-button>
        </b-card>
      </template>
      <!-- <template v-slot:cell(seconds_since_last_scan)="row">
        <p>{{row.item.seconds_since_last_scan}} J</p>
      </template> -->
      <template v-slot:cell(stock)="row">
        <div class="text-wrapper size">
          <p>{{row.item.card_in_stock}} / {{row.item.nbr_card}}</p>
        </div>
      </template>
      <template v-slot:cell(Options)="row">
        <div @contextmenu.prevent.stop="handleClick($event, row)"
             @click.prevent.stop="handleClick($event, row)"
             class="size icone-size cursor">
          <i class="fa fa-cog" aria-hidden="true"></i>
        </div>
      </template>
      <!-- <template v-slot:cell(disable)="row">
        <div> -->
          <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
          <!-- <b-button
            size="sm"
            variant="danger"
            :disabled="needsToBeDisabled(row)"
            @click="disable(row)"
            class="mr-2"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </b-button>
        </div>
      </template> -->
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          v-model="currentPage"
        />
      </b-col>
    </b-row>
    <b-modal
      title="Création de cartes temporaires"
      v-model="displayTmpCardModal"
      hide-footer>
        <b-form>
          <b-form-input
            v-model="tmpCardForm.qty"
            type="number"
            required
            placeholder="1" />
        </b-form>
        <div class="btn-modal">
          <b-button
              variant="danger"
              @click="closeTmpCardModal"
          >
            Fermer
          </b-button>
          <b-button
            variant="primary"
            @click="createTmpCards"
          >
            Créer les cartes
          </b-button>
        </div>
      </b-modal>
      <vue-simple-context-menu
        :elementId="'context-menu-'"
        :options="contextMenuList"
        :ref="'vueSimpleContextMenu'"
        @option-clicked="optionClicked"
      />
      <b-modal
        title="Voulez-vous vraiment désactiver ce kanban ?"
        v-model="displayDeleteValidation"
        hide-footer
      >
        <div class="deleteModalButton">
          <b-button variant="danger" @click="closeDeleteValidationModal()">Annuler</b-button>
          <b-button variant="primary" @click="disable(selectedRow)">Confirmer</b-button>
        </div>
      </b-modal>
  </div>
</template>
<script>
import server from '../../api/server.vue'
import referenceApi from '../../api/reference.vue'
import { mapGetters } from 'vuex'
import printHeureServer from '../../api/printHeureServer.vue'
import router from '../../app/router/router.js'
import VueSimpleContextMenu from 'vue-simple-context-menu'
import { Steps } from '../../core/services/steps.js'


export default {
  name: 'ExternalLoopRefList',
  components: {
    'vue-simple-context-menu': VueSimpleContextMenu,
  },
  data() {
    return {
      dict: {},
      displayTmpCardModal: false,
      displayDeleteValidation: false,
      textBtnLeadTime: "Afficher les ranking forecast A",
      currentPage: 1,
      previousRowDetailed: null,
      keep_only_lead_time: false,
      totalRows: 0,
      rankingFilter: '',
      isBusy: false,
      filter: null,
      positionFilter: null,
      actualCtx: '',
      nbDay: '',
      perPage: 20,
      bordered: true,
      outlined: true,
      selectedRow: {},
      nbDay: '',
      steps: JSON.parse(JSON.stringify(Steps)),
      tmpCardForm: {reference: '', qty: 0, loop: 'loop_external', supplier: ''},
      detailsFields: [
        { key: 'card_id', sortable: true },
        { key: 'card_index', sortable: true },
        // { key: 'removed', sortable: true },
        {
          key: 'seconds_since_last_scan',
          label: 'Jours depuis le dernier scan',
          sortable: true
        },
        {
          key: 'last_print_at',
          label: 'Carte imprimée le',
          sortable: true
        },
        {key: 'supplier', label: 'Fournisseur', sortable: true},
        'Imprimer',
        'Update'
      ],
      fields: [
        // { key: 'loops'},
        { key: 'reference.code_display', label: 'Code', sortable: true },
        { key: 'reference.designation', label: 'Designation', sortable: true },
        { key: 'Stock', sortable: true },
        { key: 'ranking', sortable: true },
        { key: 'supplier', sortable: true },
        { key: 'batch_size', sortable: true },
        { key: 'weight', label: 'Poids', sortable: true },
        { key: 'emplacement', sortable: true },
        { key: 'reference.takt_time', label: 'Takt Time', sortable: false },
        'Options',
      ],
      contextMenuList: [
        {
        name: '<i class="fa fa-info-circle" aria-hidden="true"></i> Hippodrome',
        slug: 'hippo'
        },
        {
        name: '<i class="fa fa-refresh" aria-hidden="true"></i> Mettre à jour le produit',
        slug: 'update'
        },
        {
        name: '<i class="fa fa-ban" aria-hidden="true"></i> Desactiver le produit',
        slug: 'disable'
        },
        {
        name: '<i class="fa fa-plus" aria-hidden="true"></i> Afficher/Cacher les détails',
        slug: 'details'
        },
        {
         type: 'divider'
        },
        {
        name: 'A',
        slug: 'A'
        },
        {
        name: 'B',
        slug: 'B'
        },
        {
        name: 'C',
        slug: 'C'
        },
        {
        name: 'D',
        slug: 'D'
        },
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedCode'])
  },
  methods: {
    toggleLeadTime() {
      this.textBtnLeadTime = !this.keep_only_lead_time ? "Afficher toutes les références" : "Afficher les ranking forecast A"
      this.keep_only_lead_time = !this.keep_only_lead_time
      this.$root.$emit('bv::refresh::table', 'my-table')
    },
    displayModalTmpCards(row) {
      this.selectedRow = row
      this.tmpCardForm.supplier = row.item.supplier
      this.displayTmpCardModal = true
      this.tmpCardForm.reference = row.item.reference.code
    },
    displayModalDeleteValidation(row){
      this.selectedRow = row
      this.displayDeleteValidation = true
    },
    closeTmpCardModal() {
      this.displayTmpCardModal = false
    },
    closeDeleteValidationModal() {
      this.displayDeleteValidation = false
    },
    createTmpCards () {
      server.createTmpCards(this.tmpCardForm).then((result) => {
        this.$toasted.success(`${this.tmpCardForm.qty} cartes pour ${this.tmpCardForm.reference} créées`)
        this.displayTmpCardModal = false
        this.selectedRow.toggleDetails()
        this.showDetail(this.selectedRow)
      }).catch((error) => {
        this.$toasted.error(`Mince ! Une erreur <br> ${error}`)
      })
    },
    goToUpdateCardInfos(row) {
        this.$store.commit('setActualLoop', 'loop_external')
        this.goTo('/update_card_infos/' + row.item.kanban_reference.reference.code)
    },
    recomputeCards(row) {
      server
        .recalculateCardsByKanbanRef(
          row.item.reference.code,
          row.item.nbr_card,
          'loop_external'
        )
        .then(result => {
          this.showDetail(row)
        })
    },
    updateLastPrint (card_id) {
      server.updateLastPrintCard(card_id).then(() => {
      })
    },
    printCard (row) {
        let sageBarcode = row.item.kanban_reference.reference.code + '\\9\\9' +  row.item.kanban_reference.batch_size

        if(row.item.card_index === -1) {
          sageBarcode = 'Carte à jeter'
        }
        console.log(row)
        if (!row.item.supplier.supplier_code) {
            row.item.supplier.supplier_code = ' '
        }
        let data = [{'EMPLACEMENT': row.item.kanban_reference.reference.supermarket_emplacement,
                'REFERENCE': this.chunk(row.item.kanban_reference.reference.code, 3),
                'CARD_ID': row.item.card_id,
                'DESIGNATION': row.item.kanban_reference.reference.designation,
                'FOURNISSEUR': row.item.supplier.supplier,
                'CODE_FOURNISSEUR': row.item.kanban_reference.supplier_code,
                'POIDS': row.item.kanban_reference.reference.weight,
                'NUM_CARTE': row.item.card_index,
                'NB_CARTE': row.item.kanban_reference.nbr_card,
                'TAILLE_LOT': row.item.kanban_reference.batch_size,
                'SAGEBARCODE': sageBarcode }]
        printHeureServer.printCard(data).then(() => {
            this.makeToast('Impression en cours...')
            this.updateLastPrint(row.item.card_id)
        })
    },
    printAllCards(detailsItems) {
        let data = []
        detailsItems.forEach(element => {
            if (!element.supplier.supplier_code) {
              element.supplier.supplier_code = ' '
            }
            data.push({'EMPLACEMENT': element.kanban_reference.reference.supermarket_emplacement,
                        'REFERENCE': this.chunk(element.kanban_reference.reference.code, 3),
                        'CARD_ID': element.card_id,
                        'DESIGNATION': element.kanban_reference.reference.designation,
                        'FOURNISSEUR': element.supplier.supplier,
                        'CODE_FOURNISSEUR': element.kanban_reference.supplier_code,
                        'POIDS': element.kanban_reference.reference.weight,
                        'NUM_CARTE': element.card_index,
                        'NB_CARTE': element.kanban_reference.nbr_card,
                        'TAILLE_LOT': element.kanban_reference.batch_size,
                        'SAGEBARCODE': element.kanban_reference.reference.code + '\\9\\9' +  element.kanban_reference.batch_size})
          })
        printHeureServer.printCard(data).then(() => {
            this.makeToast('Impression en cours...')
            detailsItems.forEach(card => this.updateLastPrint(card.card_id))
        })
    },
    printFlowrackTicket (row) {
      let data = [{'REFERENCE': this.chunk(row.item.reference.code, 3),
                   'DESIGNATION': row.item.reference.designation,
                   'BARCODE': row.item.reference.code + '-' + row.item.reference.supermarket_emplacement,
      }]
      printHeureServer.printFlowrack(data).then(() => {
        this.makeToast('Impression en cours...')
      })
    },
    addNewReference() {
      this.$store.commit('setSelectedCode', '')
      this.$store.commit('setActualLoop', 'loop_external')
      this.goTo('/references/new/')
    },
    needsToBeDisabled(row) {
      return row.item.removed === 'Supprimé'
    },
    disable(row) {
      referenceApi.removeReference(row.item.reference.code).then(result => {
        row.item.removed = 'Supprimé'
        row.item.loops = []
        this.closeDeleteValidationModal()
        this.forceRefresh()
      })
    },
    moveToUpdateView(row) {
      this.goTo('/references/new/' + row.item.reference.code)
    },
    sageDbEmplacementMismatch(row) {
      return row.item.andon !== ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    makeToast(result, append = false) {
      let toast = this.$toasted.success(result + ' mis à jour', {
        theme: 'bubble',
        position: 'top-right',
        duration: 5000
      })
    },
    forceRefresh() {
      this.getReferencesAsync(this.actualCtx).then(result => {
        this.$refs.table.refresh()
      })
    },
    showDetail(row) {
      server
        .getKanbanCardByReference(
          row.item.reference.code,
          'loop_external'
        )
        .then(response => {
          this.detailsItems = response.data
          for (let index = 0; index < this.detailsItems.length; index++) {
            if(this.detailsItems[index].card_index === -1){
              this.detailsItems[index]._rowVariant  = 'warning'
            }
          }
          this.totalDetailsRows = this.detailsItems.length
          if (
            this.previousRowDetailed &&
            row.item.reference.code !=
              this.previousRowDetailed.item.reference.code
          ) {
            this.previousRowDetailed.toggleDetails()
          }
          row.toggleDetails()
        })
    },
    getReferencesAsync(ctx) {
      ctx = {...ctx,keep_only_lead_time:this.keep_only_lead_time}
      if (this.positionFilter) {
        ctx = {...ctx, search_by_emplacement: this.positionFilter}
      }
      const promise1 = new Promise((resolve, reject) => {
          referenceApi.getFilteredReferencesExternal(ctx).then(response => {
            var data = response.data.references
            var formatedResult = []
            let tackI = []
            var i = 0
            this.totalRows = response.data.total_references
            for (i = 0; i < data.length ; i++) {
                if (data[i]['removed']) {
                data[i]['removed'] = 'Supprimé'
                data[i]['isActive'] = false
              } else {
                data[i]['removed'] = ''
              }
              data[i]['reference']['code_display'] = this.chunk(data[i]['reference']['code'], 3)
              data[i]['emplacement'] =
                data[i]['reference']['zone'] +
                data[i]['reference']['pos_y'] +
                ('0' + data[i]['reference']['pos_x']).slice(-2) +
                data[i]['reference']['pos_z']
              if (typeof(data[i]['reference']['lead_time']) === 'number') {
                data[i]['reference']['lead_time'] = (data[i]['reference']['lead_time'] / 3600 / 24).toFixed(1) + " J"
              }
              formatedResult.push(data[i])
            }
            let promises = []
            for(let j = 0; j < data.length ; j++) {
              promises.push(this.getTaktTime(formatedResult[j]['reference']['code']).then((response) => {
                formatedResult[j]['reference']['takt_time'] = response
              }))
            }
            Promise.all(promises).then(results => {
              resolve(formatedResult)
              this.actualCtx = ctx
            })

          })
      })
      return promise1
    },

    getTaktTime(code) {
    return server.getKanbanReferenceStats(code, 'loop_external')
      .then((result) => {
        for (const step in result.data.takt_time) {
           if (step in this.steps) {
            if (step == "Commandé") {
              for (const [key, value] of Object.entries(result.data.takt_time[step])) {
                let nbDay = (value / 3600 / 24).toFixed(1)
                 return nbDay = isNaN(nbDay) ? '?' : nbDay + ' J'
              }
            } else {
                let nbDay = (result.data.takt_time[step] / 3600 / 24).toFixed(1)
                 return nbDay = isNaN(nbDay) ? '?' : nbDay + ' J'
            }
          }
        }
      })
    },

    searchEmplacement () {
      this.getReferencesAsync(this.actualCtx).then(() => {
        this.$refs.table.refresh()
      })
    },
    optionClicked (event) {
          const option = event.option.slug
          const document = event.item
          if (option === 'update') {
            this.moveToUpdateView(document)
          } else if (option === 'disable') {
            this.displayModalDeleteValidation(document)
          } else if (option === 'hippo') {
            this.goTo('/andon/'+document.item.reference.code)
          } else if (option === 'details') {
            this.showDetail(document)
          } else if (option === 'A') {
            this.changeRanking('A', document)
          }  else if (option === 'B') {
            this.chBngeRanking('B', document)
          }  else if (option === 'C') {
            this.changeRanking('C', document)
          }  else if (option === 'D') {
            this.changeRanking('D', document)
          }
    },
    handleClick (event, row) {
      this.$refs.vueSimpleContextMenu.showMenu(event, row)
    },
    changeRanking (ranking, row) {
      const ref_id = row.item.uniqid
      server.changeReferenceRanking(ref_id ,ranking).then(() => {
      })
    },
    filterRanking (letter) {
      this.filter = letter
      this.getReferencesAsync(this.actualCtx).then(() => {
        this.$refs.table.refresh()
      })
    }
  },
  watch: {
    filter: function (val) {
      if (this.filter) {
        this.$router.push({ name: 'external_references', params: { filter: val } })
      }
    }
  },
  beforeMount: function() {
    this.filter = this.$route.params.filter
  }
}
</script>


<style type="text/css" scoped>
.btn {
  margin-left: 0px !important;
  margin-top: 2px !important;
}
#toptab {
  margin-top: 3%;
}
.lead-btn {
  float: left !important;
  margin: 10px 0px !important;
}
.size {
  height: 100%;
  width: 100%;
}
.icone-size {
  font-size: 28px;
}
.cursor {
  cursor: pointer;
}
.text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center
}
.option-row{
  display: flex;
  justify-content: space-between;
}
.deleteModalButton {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/supply/ExternalLoopRefList.vue